
import { Component, Prop, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../../framework/state';
import { getResourcePagingNew } from '../../../../../framework/client/resource';
import { getOptionLabel } from '../../../../../framework/service/options';
import { dateToDbDateString } from '../../../../../../common/framework/util/convert';

import { getVendorOptions } from '../../../../service/application_options_service';

import { getVehicleContractPurchaseInvoices } from '../../../../client/purchase_invoice_client';
import { FileMeta } from '../../../../../../common/application/model/FileMeta';
import { ApplicationResource } from '../../../../../../common/application/enumeration/ApplicationResource';
import { VehicleContractPurchaseInvoice } from '../../../../../../common/application/model/report/VehicleContractPurchaseInvoice';
import ParameterService from '../../../../service/parameter_service';
import { getPurchaseInvoiceAttachment } from '../../../../client/file_meta_client';

@Component
export default class VehicleContractPurchaseInvoices extends Vue {
    readonly resourceType = ApplicationResource.VEHICLE_CONTRACT_PURCHASE_INVOICE;
    parameterService = new ParameterService(this.resourceType);

    @Prop(String) readonly vehicleContractId!: string;

    shared = sharedState;
    local = {
        rows: [] as VehicleContractPurchaseInvoice[],
        total: 0,
        loading: false,
        selected: undefined as VehicleContractPurchaseInvoice | undefined,
        vendorOptions: [] as { id: string | undefined; label: string }[],
        parameters: this.parameterService.get(),
    };

    async mounted() {
        this.local.loading = true;

        this.local.parameters.pageSize = 1000;
        this.local.vendorOptions = await getVendorOptions();
        await this.loadAsyncData();

        this.local.loading = false;
    }

    async loadAsyncData() {
        const backendParameters = this.parameterService.getBackendParameters();
        this.local.rows = [];
        const rows = await getVehicleContractPurchaseInvoices(this.vehicleContractId);

        rows.forEach((row) => {
            this.local.rows.push(row);
        });

        if (rows.length) {
            backendParameters.set(
                'id',
                rows.map(({ id }) => id),
            );
            this.local.total = (
                await getResourcePagingNew(ApplicationResource.FILE_META, backendParameters, undefined)
            ).rowCount;
        }

        if (this.local && this.local.rows.indexOf(this.local.selected!!) == -1) {
            this.local.selected = undefined;
        }
    }

    async onSortChange(field: string, order: 'desc' | 'asc') {
        this.local.parameters.sortField = field;
        this.local.parameters.sortOrder = order;
        await this.resetPagingAndLoadData();
    }

    async onPageChange(page: number) {
        this.local.parameters.page = page;
        this.parameterService.set(this.local.parameters);
        await this.loadAsyncData();
    }

    getVendorName(id: string): string {
        return getOptionLabel(id, this.local.vendorOptions);
    }

    dateToString(date: Date): string {
        return dateToDbDateString(new Date(date));
    }

    async download(attachment: FileMeta): Promise<void> {
        const result = await getPurchaseInvoiceAttachment(`${attachment.resourceId}_${attachment.name}`);
        const aElement = document.createElement('a');
        aElement.setAttribute('download', attachment.name);
        const href = URL.createObjectURL(result);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
    }

    onRowClick(row: VehicleContractPurchaseInvoice) {
        if (this.local.selected && row.id === this.local.selected.id) {
            this.local.selected = undefined;
        }
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }

    private async resetPagingAndLoadData() {
        this.local.parameters.page = 1;
        this.parameterService.set(this.local.parameters);
        await this.loadAsyncData();
    }
}
